import GlobalAppHeader from "@/components/shared/GlobalAppHeader";
import GlobalAppFooter from "@/components/shared/GlobalAppFooter";

const CONTENT = {
  terms: {
    title: "Terms of Service",
    body: [
      "Welcome to Ponderr. By accessing or using the platform you agree to these Terms of Service.",
      "Ponderr provides multi-tenant school management, marketplace (Storez), streaming (Ponderr TV) and open-learning services. Each tenant is responsible for the accuracy of the data it uploads.",
      "Subscriptions, trials and take-rates are governed by the plan selected during onboarding.",
      "Pricing & Taxes: All subscription and marketplace prices are listed in Indian Rupees (INR, ₹) and are inclusive of applicable Goods & Services Tax (GST) unless stated otherwise. The final payable amount, including any taxes, is shown at checkout before payment.",
      "Cancellation & Refund Policy: You may cancel a subscription within 7 (seven) days of purchase to request a refund, provided the service has not been substantially consumed. Approved refunds are processed back to the original payment method within 5–7 business days. Recurring subscriptions can be cancelled anytime to stop future renewals; the current billing cycle remains active until its end.",
      "Service Delivery: Digital access (dashboards, LMS content, portals) is provisioned immediately or within 24 hours of a successful payment. Any physical deliverables sold via Storez are fulfilled by the respective vendor within the timeline shown on the product listing.",
      "Support Contact: For billing, cancellations, refunds or any service query, email support@ponderr.school. We aim to respond within 2 business days.",
      "You must not misuse the platform, attempt unauthorised access, or upload unlawful content. We may suspend accounts that violate these terms.",
      "These terms may be updated periodically; continued use constitutes acceptance of the latest version.",
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      "Ponderr respects your privacy. This policy explains what data we collect and how we use it.",
      "We collect account information, usage data and content you upload to deliver and improve the service. Student data is processed on behalf of the relevant school/tenant.",
      "We do not sell personal data. Third-party integrations (payments, messaging, embeddings) receive only the data necessary to perform their function.",
      "Payments & Card Data: All payments are processed through PCI-DSS compliant payment gateways (Razorpay and Stripe). Ponderr never sees, handles or stores your raw card numbers, CVV, or bank credentials — these are transmitted directly to and tokenised by the gateway over an encrypted connection.",
      "Personal API keys you provide (e.g. your Gemini key) are stored encrypted and used solely to fulfil your own requests.",
      "You may request access to or deletion of your data by contacting support@ponderr.school, or follow our Data Deletion instructions if you signed in via Facebook.",
    ],
  },
};

export default function LegalPage({ kind = "terms" }) {
  const c = CONTENT[kind] || CONTENT.terms;
  return (
    <div className="min-h-screen pf-app max-w-full overflow-x-hidden" data-testid={`legal-${kind}`}>
      <GlobalAppHeader />
      <section className="max-w-3xl mx-auto px-6 py-12 space-y-4">
        <h1 className="display text-4xl font-black">{c.title}</h1>
        <p className="text-xs pf-muted">Last updated {new Date().getFullYear()}</p>
        {c.body.map((p, i) => <p key={i} className="text-sm leading-relaxed pf-text">{p}</p>)}
      </section>
      <GlobalAppFooter />
    </div>
  );
}
